import { Type } from "class-transformer";
import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class GetCommissionsForInvoiceRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  @observable
  offset?: number;

  @observable
  @Type(() => Date)
  sinceDate!: Date;

  @observable
  @Type(() => Date)
  untilDate!: Date;

  @observable
  distributorId?: string;
}

export const CommissionsForInvoiceFiltersValidationRules: EntityValidationRules<GetCommissionsForInvoiceRequest> = {
  sinceDate: {
    required: true,
    isBefore: {
      condition: (entity: GetCommissionsForInvoiceRequest) => entity.untilDate,
      customMessage: "beforeUntilDate",
    },
  },
  untilDate: {
    required: true,
    isAfter: {
      condition: (entity: GetCommissionsForInvoiceRequest) => entity.sinceDate,
      customMessage: "afterSinceDate",
    },
  },
};
